import React, { Component } from "react";
import { Panel, PanelContent, PanelHeader } from "../../shared/Panel";
import AdvancedManagementNoBoundsFound from "../components/advanced-management/steps/AdvancedManagementNoBoundsFound";
import AdvancedManagementTerms from "../components/advanced-management/steps/AdvancedManagementTerms";
import AdvancedManagementSendDocuments from "../components/advanced-management/steps/AdvancedManagementSendDocuments";
import AdvancedManagementDocumentsSent from "../components/advanced-management/steps/AdvancedManagementDocumentsSent";
import Card from "../../shared/Card/Card";
import { withGetScreen } from "react-getscreen";
import { bindActionCreators } from "redux";

import { setStep, getRelationships } from "../actions/advanced-management";

import { connect } from "react-redux";
import AdvancedManagementHome from "../components/advanced-management/steps/AdvancedManagementHome";
import Loading from "../../shared/Loading/Loading";
import AdvancedManagementHasBeenReached from "../components/advanced-management/steps/AdvancedManagementHasBeenReached";
import { ROUTE_HOME } from "../shared/constants";

class AdvancedManagement extends Component {
	constructor(props) {
		super(props);

		this.state = {
			toggle: false,
			ifRenderModalTerms: false
		};
	}

	componentWillReceiveProps(props) {
		if (props.userManager !== undefined && !props.userManager) {
			window.location.href = ROUTE_HOME;
		}
	}

	renderModalTerms = () => {
		this.setState({
			ifRenderModalTerms: !this.state.ifRenderModalTerms
		});
	};

	nextStep = stepNumber => {
		this.props.setStep(stepNumber);
	};

	renderStep = () => {
		switch (this.props.dataCurrentStep) {
			case 1:
				return <AdvancedManagementHome nextStep={this.nextStep} />;
			case 2:
				return <AdvancedManagementNoBoundsFound nextStep={this.nextStep} />;
			case 3:
				return <AdvancedManagementSendDocuments nextStep={this.nextStep} />;
			case 4:
				return <AdvancedManagementDocumentsSent nextStep={this.nextStep} />;
			case 5:
				return <AdvancedManagementTerms nextStep={this.nextStep} />;
			case 6:
				return <AdvancedManagementHasBeenReached />;
			default:
				return <AdvancedManagementTerms nextStep={this.nextStep} />;
		}
	};

	renderHeaderContent = () => (
		<>
			<h1 className="advanced-management--header">Conta Família</h1>
			{this.props.isMobile() || this.props.isTablet() ? (
				<p className="advanced-management--header-info text-center">
					Vincule contas de familiares e amigos.
				</p>
			) : (
				<p className="advanced-management--header-info">
					Esta é uma funcionalidade que permite o vínculo de contas entre você, familiares e amigos.
				</p>
			)}
		</>
	);

	componentWillMount() {
		this.props.getRelationships();
	}

	render() {
		if (!this.props.userManager) {
			return <Loading />;
		}

		return (
			<div className="advanced-management">
				<Panel className="advanced-management__container">
					<PanelHeader className="advanced-management__panel-header">
						{this.props.isMobile() || this.props.isTablet() ? (
							<Card withoutMargin>{this.renderHeaderContent()}</Card>
						) : (
							this.renderHeaderContent()
						)}
					</PanelHeader>
					<PanelContent>
						{this.renderStep()}
					</PanelContent>
				</Panel>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	...state.advancedManagement
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setStep,
			getRelationships
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(
	withGetScreen(AdvancedManagement, {
		mobileLimit: 469, // TODO Fix screen vars
		tabletLimit: 769, // TODO Fix screen vars
		shouldListenOnResize: true
	})
);
